// Shared admin primitives extracted from the old monolithic AdminDashboard.
// Keep these components dumb & framework-agnostic; each admin submodule
// imports what it needs from here.

export const COMPONENT_TYPES = ["blade", "main_blade", "ratchet", "bit", "lockchip", "assist_blade", "overblade"];
export const MAX_PLAYERS_OPTS = [4, 8, 16, 32, 64, 128];

export function Field({ label, value, onChange, type = "text", full, testid }) {
  return (
    <div className={full ? "col-span-2" : ""}>
      <label className="text-[10px] uppercase tracking-[0.25em] font-bold text-white/40">{label}</label>
      <input data-testid={testid} type={type} value={value} onChange={(e) => onChange(e.target.value)}
        className="w-full bg-transparent border border-white/15 px-3 py-2 mt-1 text-sm focus:outline-none focus:border-[#00E5FF]" />
    </div>
  );
}

export function Select({ label, value, options, onChange }) {
  return (
    <div>
      <label className="text-[10px] uppercase tracking-[0.25em] font-bold text-white/40">{label}</label>
      <select value={value || ""} onChange={(e) => onChange(e.target.value)}
        className="w-full bg-transparent border border-white/15 px-2 py-2 mt-1 text-xs focus:outline-none focus:border-[#00E5FF]">
        <option className="bg-[#0C0C14]" value="">—</option>
        {options.map((o) => <option key={o.id} className="bg-[#0C0C14]" value={o.id}>{o.name}</option>)}
      </select>
    </div>
  );
}

export function Modal({ title, onClose, children }) {
  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-[#0C0C14] border border-white/15 max-w-3xl w-full max-h-[90vh] overflow-y-auto p-6" onClick={(e) => e.stopPropagation()}>
        <div className="flex justify-between items-center pb-3 border-b border-white/10">
          <h3 className="font-display font-black uppercase italic text-2xl">{title}</h3>
          <button onClick={onClose} className="text-white/60 hover:text-white text-2xl leading-none">×</button>
        </div>
        <div className="mt-5">{children}</div>
      </div>
    </div>
  );
}

export function StatSlider({ label, value, onChange, color, testid }) {
  const v = value ?? 0;
  return (
    <div>
      <div className="flex items-baseline justify-between mb-1">
        <label className="text-[10px] uppercase tracking-[0.25em] font-bold font-mono" style={{ color }}>
          {label}
        </label>
        <span className="text-[10px] font-mono font-bold text-white/80" data-testid={`${testid}-value`}>
          {value ?? "—"}
        </span>
      </div>
      <input
        data-testid={testid}
        type="range"
        min={0}
        max={100}
        value={v}
        onChange={(e) => onChange(parseInt(e.target.value, 10))}
        className="w-full h-1.5 accent-[#FF0055] cursor-pointer"
        style={{ accentColor: color }}
      />
    </div>
  );
}

export function MiniStat({ label, value, color }) {
  return (
    <span
      className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[9px] font-mono font-bold border"
      style={{ color, borderColor: `${color}40`, background: `${color}10` }}
    >
      <span className="opacity-70">{label}</span>
      <span>{value}</span>
    </span>
  );
}

export function SettingsField({ label, value, onChange, placeholder, testid }) {
  return (
    <div>
      <label className="text-[10px] uppercase tracking-[0.25em] font-bold text-white/40 block mb-2">
        {label}
      </label>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        data-testid={testid}
        className="w-full bg-transparent border border-white/15 px-3 py-2 text-sm focus:outline-none focus:border-[#00E5FF] font-mono"
      />
    </div>
  );
}
